import { FormControl, MenuItem, Select, useTheme } from "@mui/material";
import { ISelectInput } from "./Types/Inputs.types";
import { ChevronDown, ChevronUp } from "lucide-react";

const SelectIcon = ({ className }: { className?: string }) => {
  console.log();

  const isOpen = className?.includes("MuiSelect-iconOpen");
  return isOpen ? (
    <ChevronUp className={className} size={16} />
  ) : (
    <ChevronDown className={className} size={16} />
  );
};

export const SelectInput = ({
  id,
  value,
  onChange,
  options,
  placeholder,
  sx,
  sxMenuItem,
}: ISelectInput) => {
  const theme = useTheme();

  return (
    <FormControl id={"formcontrol-select-" + id}>
      <Select
        id={id}
        value={value}
        onChange={onChange}
        displayEmpty
        IconComponent={SelectIcon}
        renderValue={(selected) => {
          const option = options.find((o) => o.value === selected);
          return option ? option.label : (placeholder ?? "");
        }}
        sx={{
          backgroundColor: `${theme.palette.backgroundPrimary} !important`,
          borderRadius: "0.5rem !important",
          border: `1px solid ${theme.palette.borderAccent}`,
          color: theme.palette.text.primary,
          height: "2.25rem",
          "& .MuiSelect-select": {
            padding: "0.65rem 0.5rem",
            fontSize: "0.75rem",
            display: "flex",
            alignItems: "center",
          },
          "& .MuiSelect-icon": {
            color: theme.palette.text.primary,
            fontSize: "1rem",
            // top: "calc(0% + .125rem)",
          },
          "& .MuiSelect-iconOpen": {
            transform: "none",
          },
          "& .MuiOutlinedInput-notchedOutline": {
            border: "none",
          },
          ...sx,
        }}
      >
        {options.map((option) => (
          <MenuItem
            key={option.value}
            value={option.value}
            sx={{
              fontSize: "0.75rem",
              ...sxMenuItem,
            }}
          >
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
